import { useCustom } from '@refinedev/core';

type UserCredentials = {
  has_password: boolean;
};

export const useUserCredentials = () => {
  const { data, isLoading, isError } = useCustom<UserCredentials>({
    url: 'me/credentials',
    method: 'get',
    queryOptions: {
      retry: false,
    },
  });

  return {
    hasPasswordSet: data?.data?.has_password ?? false,
    isLoading,
    isError,
  };
};
